import CheckIcon from '@mui/icons-material/Check';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Link } from "@mui/material";
import Grid from '@mui/material/Grid';
import { FC, useState } from 'react';

type EventGalleryPhotoProps = {

    onAddToShoppingCart: () => void;
};

const EventGalleryPhotoToolsShop: FC<EventGalleryPhotoProps> = ({
    onAddToShoppingCart }) => {

    const [isAddingToCart, setIsAddingToCart] = useState(false);

    const addToCart = () => {
        setIsAddingToCart(true);
        onAddToShoppingCart();
        setTimeout(() => setIsAddingToCart(false), 1000);
    }

    return (
        <Grid
            size={12}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 1,
            }}
        >
            <Link
                onClick={addToCart}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 1,
                    borderRadius: 1,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: isAddingToCart ? 'success.main' : 'primary.main',
                    backgroundColor: 'background.paper',
                    color: isAddingToCart ? 'success.main' : 'primary.main',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: 'action.hover',
                        borderColor: isAddingToCart ? 'success.dark' : 'primary.dark',
                        transform: 'scale(1.05)',
                    },
                }}
            >
                {
                    isAddingToCart
                        ? <CheckIcon
                            sx={{
                                color: 'success.main',
                                fontSize: '1.5rem',
                            }}
                        />
                        : <ShoppingCartIcon
                            sx={{
                                color: 'primary.main',
                                fontSize: '1.5rem',
                            }}
                        />
                }
            </Link>
        </Grid>
    );
};

export { EventGalleryPhotoToolsShop };
